import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraAuto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCameraAuto"><Path d="M2.5 6.5H7.5L9.5 3.5H14.5L16.5 6.5H21.5V20.5H2.5V6.5Z" stroke="currentColor" strokeLinecap="square"/><Path fillRule="evenodd" clipRule="evenodd" d="M8.29425 16.8477L11.5433 9.5H12.4598L15.7088 16.8477C15.7308 16.8974 15.744 16.9487 15.7492 17H14.6828L13.7984 15H10.2047L9.32033 17H8.25391C8.25906 16.9487 8.27229 16.8974 8.29425 16.8477ZM13.3562 14L12.0015 10.9363L10.6469 14H13.3562Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraAuto;
